import axios from "axios";
import { jwtDecode } from "jwt-decode";

import AsyncLocalStorage from "@createnextapp/async-local-storage";

const TOKEN_KEY = process.env.REACT_APP_LOCAL_STORAGE_KEY;

const authService = {
  // Llamada HTTP para obtener el token
  async logout() {
    this.deleteToken();
    window.location.href = process.env.REACT_APP_FALLBACK_NO_PROJECT_URL;
  },
  getRoles() {
    const token = this.getToken();
    if (token == null) {
      return null;
    }
    const decoded_jwt = jwtDecode(token);
    const obj_jwt = JSON.parse(decoded_jwt["payload"]);
    if ("roles" in obj_jwt) {
      let new_roles = [];
      for (let rol of obj_jwt["roles"]) {
        new_roles.push(rol["name"]);
      }
      return new_roles;
    }
    return null;
  },
  checkIfTokenIsOk(token) {
    let decoded = jwtDecode(token);
    let now = new Date();
    let exp_date = new Date(0); // The 0 there is the key, which sets the date to the epoch
    exp_date.setUTCSeconds(decoded["exp"]);
    return exp_date > now;
  },

  // Guardar el token en el almacenamiento local
  saveToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },

  // Obtener el token del almacenamiento local
  getToken() {
    const tk = localStorage.getItem(TOKEN_KEY);
    if (tk === null) {
      return null;
    }
    if (this.checkIfTokenIsOk(tk)) {
      return tk;
    } else {
      this.deleteToken();
      return null;
    }
  },

  // Eliminar el token del almacenamiento local
  deleteToken() {
    localStorage.removeItem(TOKEN_KEY);
  },
};

export default authService;
